import {ADD_AB_TEST_DATA, IAddTestAction, ISetABTestingInitializedAction, SET_AB_TESTING_INITIALIZED} from "../actions/ab_testing_action";

export type IABTestingStore = {
    tests: Record<string, number>;
    isInitialized: boolean;
    forcedVariant: number | null;
};

type ActionType = IAddTestAction | ISetABTestingInitializedAction;

export const abTestingReducer = (state: IABTestingStore = {tests: {}, isInitialized: false, forcedVariant: null}, action: ActionType): IABTestingStore => {
    switch (action.type) {
        case ADD_AB_TEST_DATA:
            const {id, variant} = action.abTest;

            const selectedVariant = Number.isFinite(state.forcedVariant) ? (state.forcedVariant as number) : variant;

            return {...state, tests: {...state.tests, [id]: selectedVariant}};
        case SET_AB_TESTING_INITIALIZED: {
            return {...state, isInitialized: true};
        }
        default:
            return state;
    }
};
import {ADD_AB_TEST_DATA, IAddTestAction, ISetABTestingInitializedAction, SET_AB_TESTING_INITIALIZED} from "../actions/ab_testing_action";

export type IABTestingStore = {
    tests: Record<string, number>;
    isInitialized: boolean;
    forcedVariant: number | null;
};

type ActionType = IAddTestAction | ISetABTestingInitializedAction;

export const abTestingReducer = (state: IABTestingStore = {tests: {}, isInitialized: false, forcedVariant: null}, action: ActionType): IABTestingStore => {
    switch (action.type) {
        case ADD_AB_TEST_DATA:
            const {id, variant} = action.abTest;

            const selectedVariant = Number.isFinite(state.forcedVariant) ? (state.forcedVariant as number) : variant;

            return {...state, tests: {...state.tests, [id]: selectedVariant}};
        case SET_AB_TESTING_INITIALIZED: {
            return {...state, isInitialized: true};
        }
        default:
            return state;
    }
};
